import { render, staticRenderFns } from "./ServiceManagerCommentNote.vue?vue&type=template&id=17913d2a&scoped=true&"
import script from "./ServiceManagerCommentNote.vue?vue&type=script&lang=js&"
export * from "./ServiceManagerCommentNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17913d2a",
  null
  
)

export default component.exports